import { withStylePrefix } from '../../common/withStylePrefix';
import { ProgressStepPanelComponent, progressStepPanelTemplate } from './ProgressStepPanel';
import styles from './ProgressStepPanel.styles.scss';
export const progressStepPanelDefinition = {
    baseName: 'progress-steppanel',
    template: progressStepPanelTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonProgressStepPanel = ProgressStepPanelComponent.compose(progressStepPanelDefinition);
